<template lang="html">
  <th>
    <span class="d-flex align-items-center">
      <span>{{ headerLabel }}</span>
      <span class="ml-1" style="font-size: 0.8rem">
        <i class="fas fa-caret-down" v-if="sortKey === keySlug && !isReverse"></i>
        <i class="fas fa-caret-up" v-else-if="sortKey === keySlug && isReverse"></i>
        <i class="fal fa-sort" v-else></i>
      </span>
    </span>
  </th>
</template>

<script>
export default {
  props: {
    sortKey: {
      type: String,
      default: ''
    },
    headerLabel: {
      type: String,
      default: ''
    },
    keySlug: {
      type: String,
      default: ''
    },
    isReverse: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
th {
  cursor: pointer;
  line-height: 1.5;
  &:hover {
    color: var(--action);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Floorplan/FloorplanTableHeader.vue